import * as THREE from 'three';
import { FikoSahne } from './FikoSahne';

export class FikoObje3D extends THREE.Object3D {
    // sahne?: FikoSahne;
    override type: string = "FikoObject3D";

    /// Listede Yada Çizimde Sol Tıklamada Gelicek Komutlar RS+: Bilmiyorm Daha Sadece Fiko Çizimlerde Kullanmışım YAP:  Büyük İhtimal Kaldıracam
    komutlar?: {
        baslik?: string;
        simge?: string | null;
        simgeYazi?: string | null;
        renkSinif?: string;
        renk?: string;
        tiklandi?: () => void;
    }[] = null


    /// RS+: Listede Yada Çizimde Sağ Tıklamada Gelicek Komutlar
    sagMenu?: {
        baslik?: string;
        simge?: string | null;
        simgeYazi?: string | null;
        renkSinif?: string;
        renk?: string;
        tiklandi?: () => void;
    }[] = null;

    /// RS+: Seçildiğinde Sol Taraftaki Araç Çubuğuna Gelicek Komutlar
    solAracCubugu?: {
        baslik?: string;
        simge?: string | null;
        simgeYazi?: string | null;
        renkSinif?: string;
        renk?: string;
        tiklandi?: () => void;
    }[] = null;

    /// RS+: Uzun Basıldığında Oluşacak Komutlar
    hizli3DMenu?: {
        baslik?: string;
        simge?: string | null;
        simgeYazi?: string | null;
        renkSinif?: string;
        renk?: string;
        tiklandi?: () => void;
    }[] = null;

    hizliMenu3DBilgi?: string = null;

    /// RS+: Sol Tuş İle Uzun Basıldığında Komutların Altında Gözükecek Angular Bileşeni
    hizliMenu3DEk?: any = null;
    hizliMenu3DEkParametreler?: any = null;// { element: this };

    constructor(public sahne?: FikoSahne) {
        super();
        this.userData['FikoParametreler'] = [];
        this.userData['FikoArayuz'] = {};
    }

    hazirla?(sahne?: FikoSahne) {
        // super.hazirla(sahne);
        this.sahne = sahne;
    }


    ekle?(...objeler: THREE.Object3D[]): FikoObje3D {
        super.add(...objeler);
        return this;
    }

    /** userData'yi JSON-serializable formata cevir (fonksiyonlar ve circular ref'ler haric) */
    _serializeUserData(): any {
        const sonuc: any = {};
        for (const key of Object.keys(this.userData)) {
            const val = this.userData[key];
            if (val === undefined || typeof val === 'function') continue;
            try {
                // Vector3 vb. Three.js objeleri icin toArray kontrolu
                if (val && typeof val === 'object' && typeof val.toArray === 'function') {
                    sonuc[key] = { _v3: true, data: val.toArray() };
                } else {
                    // Serialize edilebilirlik testi
                    JSON.stringify(val);
                    sonuc[key] = val;
                }
            } catch {
                // Circular ref veya serialize edilemez - atla
            }
        }
        return sonuc;
    }

    /** JSON'dan userData'yi geri yukle (mevcut key'lerin ustune yaz, yeni key'leri ekle) */
    _restoreUserData(json: any): void {
        if (!json || typeof json !== 'object') return;
        for (const key of Object.keys(json)) {
            const val = json[key];
            // Vector3 restore
            if (val && typeof val === 'object' && val._v3 && Array.isArray(val.data)) {
                this.userData[key] = new THREE.Vector3().fromArray(val.data);
            } else {
                this.userData[key] = val;
            }
        }
    }


    // public get matrix(): Matrix4 {
    //     return super.matrix;
    // }
    // public set matrix(v: Matrix4) {
    //     super.matrix = v;
    // }

}